import React from 'react'

import {useTranslation} from '@lib/intl/useTranslations'
import {shallow} from 'zustand/shallow'

import useQueryFetchMe from '@hook/query/account/useQueryFetchMe'
import {useLoginStore} from '@store/LoginStore'

import {getLinkUrl, URL_LEADERBOARD, URL_PORTFOLIO, URL_PORTFOLIO_SIGN_UP, URL_TOKEN} from '@constant/url'

import {IGlobalNavigationStyles} from '@component/header/GlobalNavigation/GlobalNavigation'
import {MatchingType} from '@component/buttons/WizNavButton'

import NavButton from '@component/header/GlobalNavigation/NavButton'
import NavigationCommunityTitle from '@component/header/GlobalNavigation/NavigationOperations/NavigationCommunityTitle'
import {useLoginModalStore} from '@store/LoginModalStore'
import NavigationFeaturesTitle from '@component/header/GlobalNavigation/NavigationOperations/NavigationFeaturesTitle'

interface IProps {
    className?: string
    navStyles?: IGlobalNavigationStyles
    isScrolled?: boolean
}

const NavigationTitleOperations: React.FC<IProps> = ({className, navStyles, isScrolled}) => {
    const t = useTranslation()

    const {id} = useLoginStore(state => ({id: state.id}), shallow)
    const showLoginModal = useLoginModalStore(state => state.showLoginModal)
    const {data: me} = useQueryFetchMe(undefined, false)

    return (
        <div className={'flex grow gap-x-[22px] ml-[30px] mr-[5px] flex-none md:hidden'}>
            <NavButton
                textClassName={navStyles?.TextPrimaryColor}
                text={t('globalNavigation.menu.leaderboard')}
                href={getLinkUrl(URL_LEADERBOARD)}
                matchingCondition={[{type: MatchingType.Equal, url: '/leaderboard'}]}
                isScrolled={isScrolled}
            />
            <NavButton
                textClassName={navStyles?.TextPrimaryColor}
                text={t('globalNavigation.menu.myPortfolio')}
                href={id ? getLinkUrl(URL_PORTFOLIO(id)) : getLinkUrl(URL_PORTFOLIO_SIGN_UP)}
                onClick={e => {
                    // if (!id) {
                    //     showLoginModal()
                    //     e?.preventDefault()
                    //     e?.stopPropagation()
                    // }
                }}
                matchingCondition={[
                    {type: MatchingType.StartWith, url: '/user/'},
                    // {type: MatchingType.Equal, url: '/user/[id]/copyfolio', query: {id: id}},
                    // {type: MatchingType.Equal, url: '/user/[id]/leaderfolio', query: {id: id}},
                    {type: MatchingType.StartWith, url: '/key/'},
                    {type: MatchingType.StartWith, url: '/bot/'},
                    {type: MatchingType.StartWith, url: '/leaderbot/'},
                ]}
                isScrolled={isScrolled}
            />

            <NavButton
                textClassName={navStyles?.TextPrimaryColor}
                text={t('globalNavigation.menu.lot.token')}
                href={URL_TOKEN}
                matchingCondition={[{type: MatchingType.Equal, url: URL_TOKEN}]}
                // rightIcon={<TokenSalesLabelItem />}
                isScrolled={isScrolled}
            />

            <NavigationCommunityTitle navStyles={navStyles} isScrolled={isScrolled} />

            <NavigationFeaturesTitle navStyles={navStyles} isScrolled={isScrolled} />
        </div>
    )
}
export default NavigationTitleOperations
